export default __webpack_public_path__ + "static/analytics_image_small-32fce0bb89d89dba7c905a294a48ec00.png";